module.exports = __webpack_public_path__ + "static/courses-01-8772ae921293c9243aafa775e8f31ee9.png";